module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_13_Wollongong-Uni.4ae1c59e2fbef1c228ef4ba8d9a3c87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_13_Wollongong-Uni.png
// module id = 775
// module chunks = 0